import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { PaymentMethodFormDialog } from "../payment-method-form-dialog";

import { Button } from "@mui/material";

export const AddPaymentMethodFormDialog = ({
  isOpen,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.post("payment-methods", {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan metode pembayaran"));

      throw error;
    }
  };

  return (
    <PaymentMethodFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Tambah Metode Pembayaran"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddPaymentMethodFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
